import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { ColorsService } from 'src/app/services/colors.service';
@Component({
  selector: 'app-business-group',
  templateUrl: './business-group.component.html',
  styleUrls: ['./business-group.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BusinessGroupComponent {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  messageTypeCtrl = new FormControl('');
  selectedStateTypes: string[] = [];
  allStateTypes: string[] = [];
  @ViewChild('messageTypeInput') messageTypeInput!: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);

  passThrough:any
  search:any={searchText:""}
  pagestr:any={
    number:'0',
    size:'10'
  }
 
 
  action:any
  groupList:any
  settingJson:any
  totalElements:any=0
  menu:any="20px";
  showGroup:boolean=false;
  showGroupPopup:boolean=false
  columnsGroupDisplay: string[] = ['name','status','creationDate',];
 
  GroupRegFg! : FormGroup
  dataSource:any = [];
  groupData:any = [];
  expandedElement!: any | null;
  color:any
constructor(private StaticdataService:StaticdataService,private PaymentConfigService:PaymentConfigService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
  private AirManagementService:AirManagementService,private userPrivileges: UserPrivilegeService,private ColorsService:ColorsService,
  ){




    this.userPrivileges.userPrivilegesByModule('business-group').then((privileges:any) => {
      this.privilegesValue(privileges)
    })
    .catch((error:any) => {
    console.error(error); // Handle errors, if any
    });

    this.ColorsService.colors("","").then((color:any) => {
      this.color=color
     })
     .catch((error:any) => {
     });

   
  this.SettingsService.airManageJson().then((data:any) => {
    this.settingJson=data["menu"]
    this.showGroup=true
   })
   .catch((error:any) => {
   });

   this.dataFields();
   this.getGrouplist({page: this.pagestr.number, size: this.pagestr.size,})
  

}
privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

dataFields(){
  this.GroupRegFg=this.fb.group({
    "code" :  ['',[Validators.required]],
    "name" : ['',[Validators.required]],
    "status":['A',[Validators.required]],
  });
  
  
}

OnClickLink(subMenu:any){
  if(subMenu==="Amadeus"){
  this.router.navigate(["/app/Air-Management/Amadeus"]);}
  else if(subMenu==="User"){
    this.router.navigate(["/app/Air-Management/User-config"]);

  }

}


  backClick(){
window.location.href="/app/settings"
  }


 
 
 
  onClickGroup(){
   
    this.showGroup=true;
  
  }
 
 
 
  onAddGroup(){
    this.action='newGrp'
    this.showGroupPopup=true

  }
  
  closePopup() {
   

    this.showGroupPopup=false
    this.dataFields()
  }
 

  AddGroup() {
    this.AirManagementService.saveBusinessGroup(this.GroupRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Group Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showGroupPopup=false
           this.getGrouplist({page: this.pagestr.number, size: this.pagestr.size,})

          } else {
            const body : any = res.body;
            this.registerGroupErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerGroupErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerGroupErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Group",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Group",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchUser(){
  
    this.getGrouplist({page: this.pagestr.number, size: this.pagestr.size,})
  }

  nextPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getGrouplist(page)
    //this.getAllUser(page)
  
  }
  getGrouplist(page:any){

    this.AirManagementService
    .getBusinessGroupList(page,this.search)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pagestr.number=data.result['number']
            this.pagestr.size=data.result['size']
          }

         // this.Userlist=data.result.content;
         console.log(res)
          this.groupData=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.groupData.length>0){
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  Grouplist(){

    this.AirManagementService
    .businessGrouplist()
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data=res
       this.groupList=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

 





 
  
 

 



  



  

  rowGroupClick(item:any){
    this.action='updateGrp'

    this.showGroupPopup=true;

    this.GroupRegFg=this.fb.group({
      "code" :  [item.code,[Validators.required]],
      "name" : [item.name,[Validators.required]],
      "status":[item.status,[Validators.required]],
    });
  }
  



  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  onlyNumberSpecialKey(event: any): boolean {
    let charCode = (event.which) ? event.which : event.keyCode;

    // Allow numbers (48-57), plus sign (+ which is 43), minus sign (- which is 45), and colon (: which is 58)
    if (
        (charCode >= 48 && charCode <= 57) ||  // Allow numbers
        charCode === 43 ||  // Allow plus sign (+)
        charCode === 45 ||  // Allow minus sign (-)
        charCode === 58     // Allow colon (:)
    ) {
        return true;
    }

    // Prevent default for other characters
    return false;
}
  disable=false


}
